
  <h1 mat-dialog-title>Imágenes claves</h1>

  <div style="margin-bottom: 10px;">
  <button mat-button type="button" (click)="selectAll()">Seleccionar todas</button>
  <button mat-button type="button" (click)="clearSelection()">Borrar selección</button>
</div>

    <div class="key-image-list">
      <div class="key-image-item" *ngFor="let id of ids">
        <mat-checkbox [checked]="isSelected(id)" (change)="selectedImage(id)"></mat-checkbox>
        <img [src]="getImageUrl(id)">
      </div>
  </div>

  <div class="clearfix">
      <div class="pull-right">
          <button mat-button type="button" (click)="save()">Aceptar</button>
          <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
      </div>
  </div>
